import { useContext, useCallback } from 'react';

import { FavouritesContext } from '../../state/favourites';

const useFavourite = (category, value, getField = ({ id }) => id) => {
  const {
    [category]: values = [],
    actions: { addFavourite, removeFavourite },
  } = useContext(FavouritesContext);

  const favourited = values.map(getField).includes(value);

  const toggleFavourite = useCallback(
    () =>
      favourited
        ? removeFavourite(value, category)
        : addFavourite(value, category),
    [favourited, addFavourite, removeFavourite, value, category]
  );

  return [favourited, toggleFavourite];
};

export default useFavourite;
